import React, { useState } from "react";
import { toast } from "sonner";
import { Download, Trash2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export const DataControls = () => {
  const [downloading, setDownloading] = useState(false);
  const [confirm, setConfirm] = useState("");
  const [deleting, setDeleting] = useState(false);

  const download = async () => {
    setDownloading(true);
    try {
      const r = await api.get("/me/export", { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `oddlytrue-data-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Your data export has downloaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not export data");
    } finally {
      setDownloading(false);
    }
  };

  const remove = async () => {
    setDeleting(true);
    try {
      await api.delete("/me", { data: { confirm } });
      toast.success("Your account and data have been deleted");
      window.location.assign("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not delete account");
      setDeleting(false);
    }
  };

  return (
    <div className="mt-10 space-y-4">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Your data (GDPR)</p>

      <div id="export" data-testid="export-section" className="rounded-2xl border border-slate-200 bg-white p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex-1">
          <h2 className="font-display text-lg font-bold text-ink">Download my data</h2>
          <p className="mt-1 text-sm text-ink-muted">A JSON file with your profile, date of birth, consents, saved events and the emails we've sent you.</p>
        </div>
        <button type="button" data-testid="export-data-btn" onClick={download} disabled={downloading} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-ink text-ink text-sm font-semibold hover:bg-ink hover:text-white disabled:opacity-60 transition-colors">
          <Download className="w-4 h-4" /> {downloading ? "Preparing…" : "Download"}
        </button>
      </div>

      <div id="delete" data-testid="delete-section" className="rounded-2xl border border-[#c2410c]/40 bg-[#fff7ed] p-6">
        <h2 className="font-display text-lg font-bold text-ink">Delete my account</h2>
        <p className="mt-1 text-sm text-ink-muted">Permanently removes your profile, saved events, consents and email history, and stops all emails. This cannot be undone.</p>
        <div className="mt-4 flex flex-col sm:flex-row gap-3">
          <input
            data-testid="delete-confirm-input"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder='Type DELETE to confirm'
            className="flex-1 px-4 py-2.5 rounded-xl bg-white border border-slate-200 text-ink focus:outline-none focus:border-[#c2410c] transition-colors"
          />
          <button type="button" data-testid="delete-account-btn" onClick={remove} disabled={confirm !== "DELETE" || deleting} className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-[#c2410c] text-white text-sm font-semibold hover:bg-[#9a3412] disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            <Trash2 className="w-4 h-4" /> {deleting ? "Deleting…" : "Delete account"}
          </button>
        </div>
      </div>
    </div>
  );
};
